// extracted by mini-css-extract-plugin
export var breadcrumb = "_1c-2";
export var breadcrumbArrow = "_1c-3";
export var breadcrumbs = "_1c-0";
export var link = "_1c-4";
export var small = "_1c-1";